import { Icon } from '@chakra-ui/react'
import { IconProps } from './helpers'

export const RightArrowIcon = ({
  fill = 'softBlack',
  size = 12,
  opacity = '100%',
}: IconProps) => {
  return (
    <Icon
      viewBox="0 0 12 9"
      width={size}
      height={size}
      opacity={opacity}
      fill="none"
    >
      <path
        stroke={fill}
        strokeLinecap="round"
        d="M4.62.611 1 4.5l3.62 3.889"
      />
      <path fill={fill} d="M11 5a.5.5 0 0 0 0-1v1ZM1.173 5H11V4H1.173v1Z" />
    </Icon>
  )
}
